import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

import { takeUntil } from 'rxjs';

import { IDisplaySchema, SummitDisposing, SummitIdObject, ViewField } from '@summit/models';
import { ApiError } from '@summit/ui';

import { ValidationMessage } from '@summit/core';
import { SFormError } from '../../directives';

@Component({
  selector: 's-form-error-input',
  templateUrl: './s-form-error-input.component.html',
  standalone: true,
  imports: [SFormError],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SFormErrorInputComponent<T extends SummitIdObject> extends SummitDisposing implements OnInit {
  @Input() schema: IDisplaySchema<T> | false | null;
  @Input() groupName: string;
  @Input() fieldName?: keyof T | string;
  property?: ViewField<T>;
  @Input() apiError: ApiError;
  @Input() form: FormGroup;
  control: AbstractControl | null = null;
  validationMessages: ValidationMessage[] = [];
  debugging = false;

  constructor(private cd: ChangeDetectorRef) {
    super();
  }
  /*
  ngOnChanges(changes: SimpleChanges): void {
    console.log(`[Form-Error] ${this.fieldName} change!`, this.apiError);
  }
*/
  // TODO validate that api-errors show correctly in form-error in a sub-form

  ngOnInit() {
    this.debugging = false; //this.fieldName === 'newStatusDate';
    const fieldName = this.fieldName?.toString();
    if (!this.fieldName && this.fieldName !== null && this.schema !== false) {
      console.error('Field not set');
    }
    if (!this.form) {
      if (this.schema !== false && this.schema !== null) console.warn('Form not set');
    } else {
      this.control = fieldName ? this.form.get(fieldName) : null;
      this.form.statusChanges.pipe(takeUntil(this.disposing$)).subscribe((_status) => {
        if (this.debugging) {
          //console.log(`[${this.fieldName.toString()}] New Form Status: `, _status);
          //console.log(`[${this.fieldName.toString()}] Control: `, this.control.errors);
          //console.log(`[${this.fieldName.toString()}] Control: error`, this.control.hasError('customRequired'));
          // console.log(
          //   `[${this.fieldName.toString()}] Control: value`,
          //   this.control.hasError('customRequired').valueOf()
          // );
          // console.log(
          //   `[${this.fieldName.toString()}] Control: touched || dirty`,
          //   this.control.touched,
          //   this.control.dirty
          // );
        }
        this.cd.markForCheck();
      });
    }
    if (!this.control && this.fieldName && this.schema !== null && this.schema !== false) {
      console.warn(`${this.groupName ?? '[root]'}:${this.fieldName?.toString()} Control doesn't exist in form`);
    }
    if (this.schema) {
      if (this.schema.refColumnList) {
        // console.log(`getting property ${this.fieldName} on branch ${this.groupName} in `, this.schema.refColumnList);
        if (fieldName) {
          this.property = this.schema?.getAttribute(fieldName as keyof T, this.groupName);
        }
      } else {
        console.warn(`Object doesn't have refColumnList`);
      }
      if (this.property) {
        //console.log(`Found: ${this.fieldName.toString()}`, this.property);
        this.validationMessages = this.property.validationMessages ?? [];
        if (this.debugging) {
          console.log(`Found: ${this.fieldName?.toString()} and validation Messages of:`, this.validationMessages);
        }
      } else {
        if (this.fieldName) {
          console.warn(
            `Could not find Property ${this.fieldName?.toString()} of ${this.groupName ? this.groupName : 'Root'}`
          );
        }
      }
    } else {
      if (this.schema !== false && this.schema !== null)
        console.error(`No display details provided for ${this.fieldName?.toString()}`);
    }
    /*
    this.form.get(this.fieldName)
      .statusChanges
      .pipe(takeUntil(this.disposing$))
      .subscribe(change => {
        if (this.fieldName === 'aliasAssignments') {
          console.log(`Got change:`, change);
        }
      });
      */
  }

  hasServerErrors(): boolean {
    const fieldName = this.fieldName?.toString();
    const result = fieldName ? (this.form?.get(fieldName)?.errors?.['apiError'] ?? false) : false;
    //console.log(`[${this.fieldName}] has errors : ${result}`, this.form.get(this.fieldName));
    return result;
  }

  getServerErrors(): string[] {
    // console.log(`[${this.fieldName.toString()}] Processing Server errors`, this.apiError);
    const response = new Array<string>();
    const fieldName = this.fieldName?.toString();
    if (!fieldName) {
      return response;
    }
    const keyArray = Object.keys(this.apiError?.model ?? {});
    keyArray.forEach((key) => {
      // console.log(`Comparing ${key} to ${this.fieldName}`);
      const correctedKey = key.replace(/\[\d*\]/g, '');
      if (
        key.toLocaleLowerCase() === fieldName.toLocaleLowerCase() ||
        correctedKey.toLocaleLowerCase() === fieldName.toLocaleLowerCase()
      ) {
        response.push(...(this.apiError.model?.[key] ?? []));
      }
    });
    return response;
  }
}
